// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchModal_search__ex0Ag"};